// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles"}[chunkId] + "-" + {"230":"eff7926020fe271cbcbf","532":"95660ffe61cfb2249ef2"}[chunkId] + ".js";
};